import axios from "axios";
import { CUSTOMER_URL, MOBILE_CUSTOMER_URL, BASE_MOBILE_URL } from "./api";
import { authorizationHelper } from "../common/helpers";

export function getAll(page, filter) {
  const params = {
    page,
    filter
  };

  return axios.get(CUSTOMER_URL, {
    params,
    headers: { Authorization: authorizationHelper.getAuthorizationToken() }
  });
}

export function getExport() {
  const URL = CUSTOMER_URL + "/customers-export/";

  return axios.get(URL, {
    headers: { Authorization: authorizationHelper.getAuthorizationToken() }
  });
}


export function findCustomersWithPrefix(prefix) {
  const URL = CUSTOMER_URL + "/prefix/" + prefix;
  return axios.get(URL, {
    headers: { Authorization: authorizationHelper.getAuthorizationToken() }
  });
}

export function get(id) {
  const url = `${CUSTOMER_URL}/${id}`;

  return axios.get(url, {
    headers: { Authorization: authorizationHelper.getAuthorizationToken() }
  });
}

export function getSells(page, startDate, endDate, id) {
  const params = {
    page,
    startDate,
    endDate
  };
  const url = `${CUSTOMER_URL}/sells/${id}`;

  return axios.get(url, {
    params,
    headers: { Authorization: authorizationHelper.getAuthorizationToken() }
  });
}

export function bulkLoadCustomer(file) {
  const data = new FormData();
  data.append("file", file);

  const url = `${CUSTOMER_URL}/bulk-load-customer`;

  return axios.post(url, data, {
    headers: { Authorization: authorizationHelper.getAuthorizationToken() }
  });
}

export function resetPassword(token, password, confirmPassword) {
  const data = { token, password, confirmPassword };

  return axios.put(`${BASE_MOBILE_URL}/forgotpassword`, data, {
    headers: { Authorization: authorizationHelper.getAuthorizationToken() }
  });
}



// WEBPACK FOOTER //
// ./src/service/customer.js